import _ = require("underscore");
import Mediator = require("../mediator");
import BookmarkView = require("../views/BookmarkView");
import View = require("./view");
import Portal = require("portal-gis");
import Defaults = require("../models/defaults");

class Control extends View {

    static about = `
Creates a bookmark dropdown control.

Usage Example:

    <CONTROL disabled="False" id="bookmark-picker" mid="app/controls/bookmark-picker" />

    `;

    setViewOptions(options) {
        options["chosen"] = true;
        return super.setViewOptions(options);
    }

    createView() {
        _.defaults(this.options, {
            event: "bookmark-selected",
            view: "app/views/BookmarkView",
            template: "app/templates/bookmarks-template",
            region: "bookmark-picker",
            model: this.mediator.api.bookmarks
        });

        super.createView();
    }

    broadcast() {
        // why must this be done explicitly?
        this.view.collection.on("add", () => this.view.render());
        this.view.collection.on("change:text", () => this.view.render());

        this.view.on("bookmark-selected", item => this.trigger({
            viewArgs: item
        }));
        super.broadcast();
    }

}

export = Control;